class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const isCartPage = document.querySelector("cart-items");

    if (isCartPage) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer-inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer-inner") ||
          this.querySelector(".drawer-close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("cart-drawer-quick-view");
   if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "hidden";
    document.body.style.padding = "0 4px 0 0";
   }

    const animatedElements = this.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      element.classList.add("aos-animate");
    });
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-drawer-quick-view");
    if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "scroll";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
    }

    const animatedElements = this.querySelectorAll(".aos-animate");
    animatedElements.forEach((element) => {
      element.classList.remove("aos-animate");
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer-inner").classList.contains("is-empty") &&
      this.querySelector(".drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.showAddedToast();
    });
  }

  // HamppuFarmi 30.10.2026: tuote lisätään koriin avaamatta ostoskoria.
  // Näytetään pieni vahvistus, josta korin voi halutessaan avata.
  showAddedToast() {
    const lang = (document.documentElement.lang || "fi").slice(0, 2);
    const texts = {
      fi: ["Lisätty ostoskoriin", "Näytä ostoskori"],
      sv: ["Tillagd i varukorgen", "Visa varukorgen"],
      de: ["In den Warenkorb gelegt", "Warenkorb ansehen"],
      en: ["Added to cart", "View cart"],
      da: ["Lagt i kurven", "Se kurven"],
    };
    const [added, view] = texts[lang] || texts.fi;

    if (!document.getElementById("hf-cart-toast-style")) {
      const style = document.createElement("style");
      style.id = "hf-cart-toast-style";
      style.textContent =
        "#hf-cart-toast{position:fixed;left:50%;bottom:90px;z-index:1000;display:flex;gap:1.6rem;align-items:center;" +
        "padding:1.2rem 2rem;border-radius:999px;background:#346800;color:#fff;font-size:1.5rem;" +
        "box-shadow:0 8px 24px rgba(0,0,0,.2);opacity:0;pointer-events:none;transform:translate(-50%,12px);" +
        "transition:opacity .25s ease,transform .25s ease;white-space:nowrap}" +
        "#hf-cart-toast.show{opacity:1;pointer-events:auto;transform:translate(-50%,0)}" +
        "#hf-cart-toast a{color:#fff;text-decoration:underline;text-underline-offset:3px;font-weight:600}" +
        "#cart-icon-bubble.hf-bump{animation:hfBump .5s ease}" +
        "@keyframes hfBump{0%,100%{transform:scale(1)}40%{transform:scale(1.25)}}";
      document.head.appendChild(style);
    }

    let toast = document.getElementById("hf-cart-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "hf-cart-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.innerHTML = '<span class="hf-cart-toast__text"></span><a href="#"></a>';
      toast.querySelector("a").addEventListener("click", (event) => {
        event.preventDefault();
        toast.classList.remove("show");
        this.open(document.querySelector("#cart-icon-bubble"));
      });
      document.body.appendChild(toast);
    }
    toast.querySelector(".hf-cart-toast__text").textContent = "✓ " + added;
    toast.querySelector("a").textContent = view;

    const icon = document.querySelector("#cart-icon-bubble");
    if (icon) {
      icon.classList.remove("hf-bump");
      void icon.offsetWidth;
      icon.classList.add("hf-bump");
    }

    clearTimeout(this._hfToastTimer);
    requestAnimationFrame(() => toast.classList.add("show"));
    this._hfToastTimer = setTimeout(() => toast.classList.remove("show"), 4000);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer-inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
